type MarkThreadAsReadTrigger = (threadId: string) => {
  unwrap: () => Promise<unknown>
}

const pendingThreadReadRequests = new Set<string>()

export function markThreadAsReadOnce(
  threadId: string,
  hasUnread: boolean,
  markAsRead: MarkThreadAsReadTrigger
): void {
  if (!hasUnread || pendingThreadReadRequests.has(threadId)) {
    return
  }

  pendingThreadReadRequests.add(threadId)

  void markAsRead(threadId)
    .unwrap()
    .finally(() => {
      pendingThreadReadRequests.delete(threadId)
    })
}